module.exports = __webpack_public_path__ + "img/gigihpack-background-image.f02f4764.png";